import DomUtils from './DomUtils';
import { getHeightForced, getOffsetBottom, getTextWidth, round } from './utils';
const cssPropsAbbr = {
    pl: 'paddingLeft',
    pr: 'paddingRight',
    brw: 'borderRightWidth',
    blw: 'borderLeftWidth',
    btw: 'borderTopWidth',
    bbw: 'borderBottomWidth',
};
function getCssPropsByAbbr(props) {
    return props.map(it => cssPropsAbbr[it]);
}
class Autocomplete {
    constructor(input, attrs, initialize = false) {
        var _a;
        this.events = { select: [] };
        this.usingKeys = [];
        this.defaultAttrs = {
            suggestions: [],
            isSortHints: true,
            hintsLimit: 30,
            baseClass: 'nb_autocomplete',
            selectFirstOnBlur: true,
            useHelperText: false,
            qtyDisplayHints: 10,
            isAdaptiveField: false,
            onSelect: undefined,
            minFieldWidth: undefined,
            isStrictMode: false,
            inputFieldProps: undefined,
            showHintsAfterSelect: true,
            isWithMatchMark: false,
            isSimpleSearch: true,
            searchDelay: 500,
        };
        this.hintsItemHeight = 0;
        this.hintsMaxHeight = 0;
        this.selected = '';
        this.activeHint = { index: -1, value: '' };
        this.isSelected = false;
        this.isInitialized = false;
        this.isMoving = false;
        this.isWaitDelay = false;
        this.attrs = this.mergeAttributes(attrs);
        this.options = this.sortOptions(this.attrs.suggestions);
        this.isStrict = this.attrs.isStrictMode;
        this.input = input;
        this.classes = {
            wrapper: this.attrs.baseClass,
            field: this.attrs.baseClass + '__field',
            hints: this.attrs.baseClass + '__hints',
            float: this.attrs.baseClass + '__float',
        };
        this.uuid = this.randomId();
        this.props = this.mergeFieldProps();
        this.hints = this.renderHints();
        this.helper = this.renderHelper();
        if ((_a = this.attrs) === null || _a === void 0 ? void 0 : _a.onSelect) {
            this.events.select.push(this.attrs.onSelect);
        }
        if (initialize)
            this.init();
    }
    mergeFieldProps() {
        var _a;
        return Object.assign({ placeholder: ((_a = this.input) === null || _a === void 0 ? void 0 : _a.placeholder) || '' }, this.attrs.inputFieldProps);
    }
    init() {
        if (this.isInitialized) {
            throw new Error('Невозможно повторно инициализировать плагин!');
        }
        if (this.isStrict) {
            this.attrs.selectFirstOnBlur = true;
        }
        this.doRender();
        this.doEvents();
        this.setAdaptiveWidth();
        this.isInitialized = true;
    }
    get value() {
        return this.selected;
    }
    set value(value) {
        this.selected = value;
    }
    get label() {
        return this.input.value;
    }
    set label(value) {
        this.input.value = value;
    }
    setAdaptiveWidth(text, def = 40) {
        var _a;
        if (!this.attrs.isAdaptiveField)
            return;
        const value = text || this.label || this.input.placeholder;
        const fonts = DomUtils.style(this.input, ['font'])[0];
        const width = getTextWidth(value, { font: fonts });
        const style = getCssPropsByAbbr(['pl', 'pr', 'brw', 'blw']);
        const sizes = DomUtils.style(this.input, style);
        const plus = sizes.map(it => it ? parseFloat(it) : 0).reduce((n, it) => n + it, 0);
        const total = width + (plus || def) + 2;
        const minWidth = (_a = this.attrs) === null || _a === void 0 ? void 0 : _a.minFieldWidth;
        DomUtils.css(this.input, {
            width: minWidth && total < parseFloat(String(minWidth))
                ? (typeof minWidth === 'string' ? minWidth : `${minWidth}px`)
                : `${round(total)}px`,
        });
    }
    doRender() {
        const parent = this.input.parentElement;
        const wrapper = document.createElement('div');
        this.input.classList.add(this.classes.field);
        this.input.setAttribute('data-uuid', this.uuid);
        wrapper.classList.add(this.classes.wrapper);
        wrapper.append(this.input);
        parent.append(wrapper);
        this.input.after(this.hints);
        const style = DomUtils.style(this.hints, getCssPropsByAbbr(['btw', 'bbw']));
        const borders = style.map(it => parseFloat(it) || 0).reduce((n, i) => n + i, 0);
        const hintHeight = getHeightForced(this.hints) - borders;
        const itemHeight = round(hintHeight / this.getCountHints(), 2);
        const qtyHints = this.attrs.qtyDisplayHints;
        const displayHeight = (itemHeight * qtyHints) + borders;
        DomUtils.css(this.hints, { maxHeight: `${displayHeight}px` });
        if (this.attrs.inputFieldProps) {
            for (const k in this.attrs.inputFieldProps) {
                this.input.setAttribute(k, this.attrs.inputFieldProps[k]);
            }
        }
        if (this.attrs.useHelperText) {
            wrapper.append(this.helper);
        }
        this.hintsItemHeight = itemHeight;
        this.hintsMaxHeight = displayHeight;
        this.selectFirstHint(this.isStrict);
    }
    doEvents() {
        this.input.addEventListener('click', this.onFieldClick.bind(this));
        this.input.addEventListener('blur', this.onFieldBlur.bind(this));
        this.input.addEventListener('input', this.onFieldInput.bind(this));
        this.input.addEventListener('keydown', this.onFieldPress.bind(this));
        this.hints.addEventListener('click', this.onHintClick.bind(this));
        this.hints.addEventListener('mouseover', this.onHintOver.bind(this));
        this.hints.addEventListener('mousemove', this.onHintMove.bind(this));
        document.addEventListener('click', this.onGlobalClick.bind(this));
    }
    renderHints() {
        const hints = document.createElement('ul');
        hints.classList.add(this.classes.hints);
        hints.setAttribute('data-uuid', this.uuid);
        DomUtils.css(hints, { display: 'none' });
        hints.append(...this.buildHints());
        return hints;
    }
    renderHelper() {
        const div = document.createElement('div');
        const span1 = document.createElement('span');
        const span2 = document.createElement('span');
        div.classList.add(this.classes.float);
        DomUtils.css(div, { display: 'none' });
        div.append(span1, span2);
        return div;
    }
    updateHints(query) {
        const list = this.filterHintItems(query);
        const out = this.buildHints(list);
        this.hints.innerHTML = '';
        this.hints.append(...out);
    }
    buildHints(options) {
        options = options || this.options;
        const slice = this.attrs.hintsLimit !== -1
            ? options.slice(0, this.attrs.hintsLimit) : options;
        const { length } = this.label;
        const oneView = (str) => {
            return str.toLowerCase().replace('ё', 'е');
        };
        const replace = (str) => {
            if (!str)
                return str;
            return str.replaceAll(' ', '&nbsp;');
        };
        const simpleMark = (label) => {
            const start = replace(label.slice(0, length));
            const finish = replace(label.slice(length));
            return `<mark>${start}</mark><span>${finish}</span>`;
        };
        const advancedMark = (label) => {
            const index = oneView(label).indexOf(oneView(this.label));
            const before = replace(label.slice(0, index));
            const mark = replace(label.slice(index, index + length));
            const after = replace(label.slice(index + length));
            return `<span>${before}</span><mark>${mark}</mark><span>${after}</span>`;
        };
        const useMark = (label) => {
            const f = oneView(this.label), s = oneView(label);
            if (this.attrs.showHintsAfterSelect && !s.includes(f))
                return label;
            if (!length || s === f)
                return label;
            return this.attrs.isSimpleSearch ? simpleMark(label) : advancedMark(label);
        };
        const renderItem = (it, i) => {
            const li = document.createElement('li');
            li.innerHTML = this.attrs.isWithMatchMark
                ? useMark(it.label) : it.label;
            li.setAttribute('data-index', String(i));
            li.setAttribute('data-value', it.value);
            return li;
        };
        return slice.map(renderItem);
    }
    doAnalyzePlace() {
        const border = 2;
        const offset = 5;
        const input = this.input.getBoundingClientRect();
        const height = this.hintsItemHeight * this.attrs.qtyDisplayHints + border;
        const before = input.top + input.height + offset;
        const needHeight = height + before;
        const changePosition = () => {
            const sides = ['bottom', 'top'];
            const style = getOffsetBottom(this.input) < height + offset ? sides[0] : sides[1];
            const invert = sides[+!sides.indexOf(style)];
            DomUtils.css(this.hints, {
                maxHeight: `${this.hintsMaxHeight}px`,
                [style]: 'calc(100% + 5px)', [invert]: 'unset',
            });
        };
        const changeHintSize = () => {
            const allow = window.innerHeight - before;
            const item = this.hintsItemHeight;
            const height = Math.floor(allow / item) * item;
            DomUtils.css(this.hints, { maxHeight: `${height}px` });
        };
        if (window.innerHeight >= needHeight)
            changePosition();
        else if (input.top + offset < height)
            changeHintSize();
        else
            changePosition();
    }
    toShowHintsBox() {
        const isHasHints = this.getCountHints() > 0;
        const showAfterClick = this.attrs.showHintsAfterSelect ? true : !this.isSelected;
        if (!(isHasHints && showAfterClick))
            return;
        if (this.attrs.showHintsAfterSelect
            && this.isSelected &&
            this.getCountHints() < this.options.length) {
            this.updateHints('');
        }
        this.doAnalyzePlace();
        this.setHintsVisible();
    }
    selectHintValue(i = 0) {
        i = i === -1 ? 0 : i;
        const label = this.getHintData(i, 'label');
        const value = this.getHintData(i, 'value');
        if (!label || !value)
            return;
        this.label = label;
        this.value = value;
        this.toHideHintsBox();
        this.updateHints();
        this.isSelected = true;
        this.notifySelect();
    }
    notifySelect(value) {
        this.events.select.forEach((cb) => cb(value !== null && value !== void 0 ? value : this.value));
    }
    showHelperText(i) {
        var _a;
        const qty = this.label.length;
        const text = ((_a = this.getHintItem(i)) === null || _a === void 0 ? void 0 : _a.innerText) || '';
        const parts = this.helper.querySelectorAll('span');
        parts[0].innerText = text.slice(0, qty);
        parts[1].innerText = text.slice(qty);
        DomUtils.css(this.helper, { display: 'block' });
    }
    hideHelperText() {
        this.helper.querySelectorAll('span').forEach((it) => {
            it.innerText = '';
        });
        DomUtils.css(this.helper, { display: 'none' });
    }
    moveByHintItems(isDown) {
        var _a;
        const list = this.getHintItems();
        const count = list.length;
        if (count < 2 && !this.activeHint.index)
            return;
        const next = this.activeHint.index === -1
            ? isDown ? 0 : count - 1
            : this.activeHint.index + (isDown ? 1 : -1);
        const safe = (() => {
            if (next >= count)
                return 0;
            else if (next < 0)
                return count - 1;
            else
                return next;
        })();
        const activeText = (_a = list === null || list === void 0 ? void 0 : list[safe]) === null || _a === void 0 ? void 0 : _a.innerText;
        this.setActiveHint(safe);
        this.setPlaceholder(activeText || null);
        if (this.label)
            this.showHelperText(safe);
        if (count <= this.attrs.qtyDisplayHints)
            return;
        const hintHeight = DomUtils.height(this.hints) - 2;
        const itemHeight = DomUtils.height(this.getHintItem(0));
        const progress = round(itemHeight * safe);
        const scroll = this.hints.scrollTop;
        const after = scroll + hintHeight - itemHeight;
        const isVisible = progress >= scroll && progress < after;
        if (isVisible)
            return;
        this.isMoving = true;
        if (!isDown)
            this.hints.scrollTo(0, safe * itemHeight);
        else {
            const scroll = (safe + 1) - this.attrs.qtyDisplayHints;
            this.hints.scrollTo(0, scroll * itemHeight);
        }
    }
    setActiveHint(index = -1) {
        var _a, _b;
        const item = this.getHintItem(index);
        const value = (_b = (_a = item === null || item === void 0 ? void 0 : item.dataset) === null || _a === void 0 ? void 0 : _a['value']) !== null && _b !== void 0 ? _b : '';
        this.getHintItems().forEach((it) => {
            it.classList.remove('active');
        });
        this.activeHint = { index, value };
        item === null || item === void 0 ? void 0 : item.classList.add('active');
    }
    toHideHintsBox() {
        this.setHintsVisible(false);
        this.setPlaceholder(null);
        this.hideHelperText();
        this.setAdaptiveWidth();
        if (!this.attrs.showHintsAfterSelect)
            this.setActiveHint(-1);
    }
    selectFirstHint(force = false) {
        var _a;
        const isNoNeed = [
            !this.attrs.selectFirstOnBlur,
            (force ? false : this.getCountHints() > 1),
            this.isSelected,
        ];
        if (isNoNeed.some(Boolean))
            return;
        const search = (label) => {
            const list = this.filterHintItems(label);
            if (list.length)
                return list[0];
            return search(label.slice(0, -1));
        };
        const data = !this.label.length
            ? (_a = this.options) === null || _a === void 0 ? void 0 : _a[0]
            : search(this.label);
        this.label = Autocomplete.abolishHTML((data === null || data === void 0 ? void 0 : data.label) || '');
        this.value = (data === null || data === void 0 ? void 0 : data.value) || '';
        this.isSelected = true;
        this.updateHints();
        this.setAdaptiveWidth(this.label);
        this.notifySelect();
    }
    static abolishHTML(html) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const value = temp.innerText;
        temp.remove();
        return value;
    }
    onSelect(callback) {
        this.events.select.push(callback);
    }
    onKeyPress(keyCode, callback) {
        this.usingKeys.push({ key: keyCode, callback });
    }
    updateSuggestions(suggestions, selectFirst = true) {
        this.options = this.sortOptions(suggestions);
        this.isSelected = false;
        this.value = '';
        this.label = '';
        this.activeHint = { index: -1, value: '' };
        this.updateHints();
        this.selectFirstHint(selectFirst);
    }
    onFieldClick() {
        this.toShowHintsBox();
    }
    onFieldBlur() {
        this.selectFirstHint(this.isStrict);
        setTimeout(() => {
            this.toHideHintsBox();
        }, 150);
    }
    onFieldPress(e) {
        const usingKeys = [
            'ArrowRight', 'Enter', 'ArrowDown', 'ArrowUp', 'Escape', 'Space',
        ];
        if (![...usingKeys, ...this.usingKeys.map(it => it.key)].includes(e.code))
            return;
        if (!this.attrs.showHintsAfterSelect && this.isSelected)
            return;
        switch (e.code) {
            case 'ArrowRight':
                const { selectionStart, value } = this.input;
                if (selectionStart !== value.length)
                    break;
            case 'Enter':
                const index = this.activeHint.index;
                this.selectHintValue(index);
                break;
            case 'ArrowDown':
            case 'ArrowUp':
                e.preventDefault();
                const isDown = e.code === 'ArrowDown';
                this.moveByHintItems(isDown);
                break;
            case 'Escape':
                const { display } = this.hints.style;
                if (display === 'none')
                    this.input.blur();
                else
                    this.toHideHintsBox();
                break;
            case 'Space':
                if (!e.ctrlKey)
                    return;
                this.toShowHintsBox();
                break;
        }
        if (!this.usingKeys.length)
            return;
        for (const { key, callback } of this.usingKeys) {
            if (e.code === key) {
                callback(e);
                break;
            }
        }
    }
    onFieldInput() {
        const __helper = () => {
            this.updateHints();
            this.doAnalyzePlace();
            this.setHintsVisible();
            this.hideHelperText();
            this.selected = '';
            this.isSelected = false;
            this.activeHint = { index: -1, value: '' };
        };
        if (this.attrs.searchDelay < 1)
            __helper();
        else {
            if (this.isWaitDelay)
                return;
            setTimeout(() => {
                __helper();
                this.isWaitDelay = false;
            }, this.attrs.searchDelay);
            this.isWaitDelay = true;
        }
    }
    onHintClick(e) {
        if (e.target === this.hints)
            return;
        const li = e.target.closest('li');
        const index = this.getHintIndex(li);
        this.selectHintValue(index);
    }
    onHintOver(e) {
        if (this.hints === e.target || this.isMoving)
            return;
        const li = e.target.closest('li');
        const index = this.getHintIndex(li);
        const text = li.innerText || this.props.placeholder;
        this.setActiveHint(index);
        this.setPlaceholder(text);
    }
    onHintMove() {
        if (!this.isMoving)
            return;
        this.isMoving = false;
    }
    onGlobalClick(e) {
        e.stopPropagation();
        const isHints = e.composedPath().includes(this.hints);
        const isInput = e.target === this.input;
        const othersList = [...document.querySelectorAll(`.${this.classes.field}`)];
        const isSimilar = othersList.some((it) => it === this.input);
        if ([isHints, isInput, isSimilar].some(Boolean))
            return;
        this.selectFirstHint(this.isStrict);
        this.toHideHintsBox();
    }
    getHintItems() {
        return [...this.hints.querySelectorAll('li')];
    }
    getHintItem(index) {
        var _a;
        return (_a = this.getHintItems()) === null || _a === void 0 ? void 0 : _a[index];
    }
    getCountHints() {
        return this.getHintItems().length;
    }
    setHintsVisible(show = true) {
        show = this.getCountHints() < 1 ? false : show;
        DomUtils.css(this.hints, { display: show ? 'block' : 'none' });
        if (!this.attrs.showHintsAfterSelect)
            this.hints.scrollTo(0, 0);
    }
    setPlaceholder(text) {
        const k = 'placeholder';
        this.input.setAttribute(k, text || this.props[k]);
    }
    getHintIndex(el) {
        var _a, _b;
        return +((_b = (_a = el === null || el === void 0 ? void 0 : el.dataset) === null || _a === void 0 ? void 0 : _a['index']) !== null && _b !== void 0 ? _b : -1);
    }
    getHintData(index, key) {
        var _a, _b, _c;
        const el = this.getHintItem(index);
        switch (key) {
            case 'label':
                return (_a = el === null || el === void 0 ? void 0 : el.innerText) !== null && _a !== void 0 ? _a : null;
            case 'value':
                return (_c = (_b = el === null || el === void 0 ? void 0 : el.dataset) === null || _b === void 0 ? void 0 : _b[key]) !== null && _c !== void 0 ? _c : null;
        }
    }
    randomId() {
        return Math.floor(Math.random() * Date.now()).toString(36);
    }
    filterHintItems(label) {
        const oneView = (str) => {
            return str.toLowerCase().replaceAll('ё', 'е');
        };
        label = oneView(label !== null && label !== void 0 ? label : this.label);
        const list = [
            (str) => oneView(str).includes(label),
            (str) => oneView(str).startsWith(label),
        ];
        const index = Number(this.attrs.isSimpleSearch);
        return this.options.filter((it) => list[index](it.label));
    }
    mergeAttributes(options) {
        if (!options || !Object.keys(options).length)
            return this.defaultAttrs;
        function merge(obj, def) {
            return Object.keys(def).reduce((acc, k) => {
                acc[k] = k in obj ? obj[k] : def[k];
                return acc;
            }, {});
        }
        return merge(options, this.defaultAttrs);
    }
    sortOptions(list) {
        const oneView = (it) => {
            return typeof it === 'object' ? it : { value: it, label: it };
        };
        const uniqList = (acc, it) => {
            if (!acc.find(n => n.label === it.label))
                acc.push(it);
            return acc;
        };
        const data = list.map(oneView).reduce(uniqList, []);
        return this.attrs.isSortHints ? data.sort((a, b) => a.label.localeCompare(b.label)) : data;
    }
}
export default Autocomplete;
